module.exports = __webpack_public_path__ + "static/img/19.504e79d3.png";